import { supabase } from './supabaseClient';
import { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import $ from "jquery";

// ── Helper seguro: retorna null se user_id não for UUID válido ──
export function getUserId() {
    const id = localStorage.getItem("user_id");
    if (!id || id === "null" || id === "undefined" || id === "NaN") return null;
    return id;
}

// ── Cache simples em memória para reduzir queries ao Supabase ──
const _cache = new Map()
function cacheGet(key, ttlMs = 60000) {
    const entry = _cache.get(key)
    if (entry && Date.now() - entry.ts < ttlMs) return entry.data
    _cache.delete(key)
    return null
}
function cacheSet(key, data) {
    _cache.set(key, { data, ts: Date.now() })
}
function cacheInvalidate(pattern) {
    for (const k of _cache.keys()) {
        if (k.includes(pattern)) _cache.delete(k)
    }
}

// ── Deduplicação de requests: se múltiplas chamadas iguais estão em voo, retorna a mesma promise ──
const _inflight = new Map()
async function dedupedQuery(key, queryFn) {
    if (_inflight.has(key)) return _inflight.get(key)
    const promise = queryFn().finally(() => _inflight.delete(key))
    _inflight.set(key, promise)
    return promise
}

// ── getPublicUrl com cache (evita 10M+ queries a storage.objects) ──
export function cachedGetPublicUrl(bucket, path) {
    const key = `puburl:${bucket}:${path}`
    const cached = cacheGet(key, 600000) // 10 min
    if (cached) return cached
    const { data } = supabase.storage.from(bucket).getPublicUrl(path)
    if (data?.publicUrl) cacheSet(key, data.publicUrl)
    return data?.publicUrl
}

function Auth() {

    const [session, setSession] = useState(null)

    useEffect(() => {

        supabase.auth.getSession().then(({ data: { session } }) => {
            setSession(session)
        })

        const {
            data: { subscription },
        } = supabase.auth.onAuthStateChange((_event, session) => {
            setSession(session)
        })

        return () => subscription.unsubscribe()
    }, [])

    const signOut = async () => {
        if (window.confirm("Confirm you want to logout?") == true) {
            const { error } = await supabase.auth.signOut();
        }
    }

    const signIn = async () => {
        await supabase.auth.signInWithOAuth({
            provider: "google"
        })
    }

    return (
        <div></div>
    )

}

async function getAllData(id) {
    const cacheKey = `simulator:all:${id}`
    const cached = cacheGet(cacheKey, 30000)
    if (cached) return cached

    const data = await dedupedQuery(cacheKey, async () => {
        const { data, error } = await supabase
            .from('simulator')
            .select('id, user_id, sport_id, name, svg_path, svg_thumb_path, created_at, background, material, body_state, socks_state, up_state, down_state, clone_state, images, inside_color, up_state2, collar, designer, productionOrder, file_path')
            .eq('user_id', id)
            .order("created_at", { ascending: false })
        return data || []
    })

    if (data) cacheSet(cacheKey, data)
    return data;
}

async function uploadMultipleImages(imagesArray) {

    var array = [];

    for (let i = 0; i < imagesArray.length; i++) {
        const image = imagesArray[i];

        const filename = `image-${Date.now()}-${i}.webp`;

        array.push(filename);

        const { data, error } = await supabase
            .storage
            .from('images')
            .upload(filename, image, {
                contentType: image.type || 'image/webp',
                upsert: true,
            });

        if (error) {
            //console.error(`Erro ao subir imagem ${i}:`, error);
        } else {
            //console.log(`Imagem ${i} enviada com sucesso:`, data);
        }
    }

    return array;
}

async function saveProject(
    data2, user_id, sport_id, fileSvgImage, svg, svg_thumb, svg_json, svg_json2, svg_json3, background,
    annotations, material, arrayImages, gif, tecidos, modular_setup_id) {


    const path_id = getUserId() + "/" + uuidv4(); // Path in the bucket

    var arrayImagesNames = await uploadMultipleImages(arrayImages);

    /*const { dataGif, errorGif } = await supabase
        .storage
        .from('gifs')
        .upload(path_id + ".gif", gif, {
            contentType: 'image/gif',
            upsert: true,
        });*/

    // Passo 1: salva o svg no storage do supabase
    const { data: uploadData, error: uploadError } = await supabase.storage
        .from("svgs")
        .upload(path_id, svg, {
            upsert: false, // Prevent overwriting existing files
        });

    if (uploadError) {
        window['toast']("Erro ao tentar salvar, tente novamente!", "info")
        return
    }

    // Passo 2: salva o svg no storage do supabase
    const { data: uploadData2, error: uploadError2 } = await supabase.storage
        .from("svgs-thumbs")
        .upload(path_id, svg_thumb, {
            upsert: false, // Prevent overwriting existing files
        });

    if (uploadError2) {
        //console.log(uploadError2)
        window['toast']("Erro ao tentar salvar, tente novamente!", "info")
        return
    }

    // Passo 3: salva o svg como json no storage do supabase
    /*const { data: uploadData3, error: uploadError3 } = await supabase.storage
        .from("svgs-json")
        .upload(path_id, svg_json, {
            upsert: false, // Prevent overwriting existing files
        });

    if (uploadError3) {
        alert("Erro ao tentar salvar, tente novamente!")
        return
    }*/

    // Passo 4: salva o svg como imagem no storage do supabase
    const { data: uploadData4, error: uploadError4 } = await supabase.storage
        .from("images")
        .upload(path_id, fileSvgImage, {
            upsert: false, // Prevent overwriting existing files
        });


    if (window.roughnessMapFile) {
        const { data: uploadData5, error: uploadError5 } = await supabase.storage
            .from("images")
            .upload(path_id + "_relevo", window.roughnessMapFile, {
                upsert: true, // Prevent overwriting existing files
            });
    }


    if (annotations) {
        const fileAnnotations = new Blob([annotations], { type: "application/json" });

        const { data: uploadData5, error: uploadError5 } = await supabase.storage
            .from("jsons")
            .upload(path_id, fileAnnotations, {
                upsert: false, // Prevent overwriting existing files
            });
    }

    if (uploadError4) {
        //console.log(uploadError4)
        window['toast']("Erro ao tentar salvar, tente novamente!", "info")
        return
    }

    const body_state = $("#state-body-ra").attr("data-state") === "checked";
    const socks_state = $("#state-socks-ra").attr("data-state") === "checked";
    const up_state = $("#state-shirt-ra").attr("data-state") === "checked";
    const down_state = $("#state-short-ra").attr("data-state") === "checked";
    const clone_state = $("#state-clone").attr("data-state") === "checked";

    const up_state2 = $("#state-shirt2-ra").attr("data-state") === "checked";

    //Passo 3: Salva tudo na tabela
    const { data, error } = await supabase
        .from('simulator')
        .insert([
            {
                user_id: user_id,
                sport_id: sport_id,
                svg_path: path_id,
                svg_thumb_path: path_id,
                background: background,
                material: material,
                name: data2.projectName,
                body_state: body_state,
                socks_state: socks_state,
                up_state: up_state,
                up_state2: up_state2,
                down_state: down_state,
                clone_state: clone_state,
                images: JSON.stringify(arrayImagesNames),
                inside_color: window.insideModelColor,
                collar: window.selected_collar,
                annotations: path_id,
                fabrics: JSON.stringify(tecidos),
                relevo: JSON.stringify(window.relevo),
                designer: data2.designer,
                productionOrder: data2.productionOrder,
                file_path: data2.filePath || null,
                modular_setup_id: modular_setup_id || null
            },
        ]).select(); // 👈 faz retornar o registro inserido

    if ($("#projects-folders").css("display") === "block") {

        const currentFolder = window.folderAPI?.getCurrentFolder();
        const idAtual = currentFolder.id;

        if (window.confirm("Salvar Projeto dentro da pasta " + currentFolder.name + " ?")) {

            if (!idAtual) return;

            const newProjectId = data?.[0]?.id; // 👈 quando usa .select(), geralmente vem array
            if (!newProjectId) return;

            // 1) pega o projectIds atual
            const { data: folderRow, error: fetchErr } = await supabase
                .from("folders")
                .select("projectIds")
                .eq("id", idAtual)
                .single();

            if (fetchErr) {
                console.error(fetchErr);
                return;
            }

            const current = Array.isArray(folderRow?.projectIds) ? folderRow.projectIds : [];

            // 2) evita duplicar
            const next = current.includes(newProjectId) ? current : [...current, newProjectId];

            // 3) atualiza jsonb com o array novo
            const { error: updErr } = await supabase
                .from("folders")
                .update({ projectIds: JSON.stringify(next) })
                .eq("id", idAtual);

            const res = window.folderAPI?.addProjectToCurrentFolder(newProjectId);

            if (res?.ok) {

                // aqui você persiste do jeito que você já faz:
                // updateFolderProjects(res.folderId, JSON.stringify(res.projectIds))
            } else {
            }

            if (updErr) console.error(updErr);
        }
    }

    if (error) {
        window['stateLoadinScreen2'](false);
        //window["setupSaved"](true);
        //console.log(error)
        window['toast']("Erro ao tentar salvar, tente novamente!", "info")
    } else {

        window['toast']("Projeto salvo com sucesso!", "info")
        cacheInvalidate("simulator")

        const body_state = $("#state-body-ra").attr("data-state") === "checked";
        const socks_state = $("#state-socks-ra").attr("data-state") === "checked";
        const up_state = $("#state-shirt-ra").attr("data-state") === "checked";
        const down_state = $("#state-short-ra").attr("data-state") === "checked";
        const clone_state = $("#state-clone").attr("data-state") === "checked";

        const up_state2 = $("#state-shirt2-ra").attr("data-state") === "checked";

        window["setupSaved"](
            false,
            data[0].id,
            path_id,
            sport_id,
            path_id,
            data2.projectName,
            body_state,
            socks_state,
            up_state,
            down_state,
            clone_state,
            JSON.stringify(arrayImagesNames),
            window.insideModelColor,
            up_state2,
            window.selected_collar,
            data[0].created_at  // ← adicionar isso
        );

        if (window.pilha)
            if (window.pilha[0])
                window["loadPilha"](window.pilha[0], window.pilhaFiles[0])
        //alert("Projeto salvo com sucesso!");
    }
}

window["saveProjectFromManager"] = saveProject;

async function deleteProjectAPI(id, name) {

    //DELETE PROJECT
    const { error } = await supabase
        .from('simulator')
        .delete()
        .eq('id', id);

    //DELETE THUMB
    const { data2, error2 } = await supabase
        .storage
        .from('svgs-thumbs')
        .remove([name + ".jpeg"])

    //DELETE SVG
    const { data3, error3 } = await supabase
        .storage
        .from('svgs')
        .remove([name + ".svg"])

    //DELETE SVG JSON
    const { data4, error4 } = await supabase
        .storage
        .from('svgs-json')
        .remove([name + ".json"])

    cacheInvalidate("simulator")
    return;
}

async function getMySaved3ds(id) {
    const myId = getUserId();
    const orgIds = await getOrgUserIds(myId);
    const cacheKey = `3ds:${orgIds.sort().join(',')}`
    const cached = cacheGet(cacheKey, 30000)
    if (cached) return cached

    const objs = await dedupedQuery(cacheKey, async () => {
        let { data, error } = await supabase
            .from('3ds')
            .select('*')
            .in('user_id', orgIds)
            .is('setup_data', null)
        if (error) console.error('[getMySaved3ds] query error:', error)
        return data || []
    })

    cacheSet(cacheKey, objs)
    return objs;
}

async function saveMy3d(user_id, name, obj, map, thumb) {

    const path_id = getUserId() + "/" + uuidv4(); // Path in the bucket

    // Passo 1: salva o obj  no storage do supabase
    const { data: uploadData, error: uploadError } = await supabase.storage
        .from("3ds")
        .upload(path_id, obj, {
            upsert: false, // Prevent overwriting existing files
        });

    // Passo 2: salva o mapa  no storage do supabase
    const { data: uploadData2, error: uploadError2 } = await supabase.storage
        .from("3ds-map")
        .upload(path_id, map, {
            upsert: false, // Prevent overwriting existing files
        });

    // Passo 3: salva o mapa  no storage do supabase
    const { data: uploadData3, error: uploadError3 } = await supabase.storage
        .from("3ds-thumbs")
        .upload(path_id, thumb, {
            upsert: false, // Prevent overwriting existing files
        });

    //Passo 3: Salva tudo na tabela
    const { data, error } = await supabase
        .from('3ds')
        .insert([
            {
                user_id: user_id,
                name: name,
                user_id: user_id,
                "3d_path": path_id
            },
        ]);

    if (error) {
        //console.log(error)
        window['toast']("Erro ao tentar salvar, tente novamente!", "info")
        window["populateObjs"](true)
    } else {
        window['toast']("Objeto salvo com sucesso!", "info")
        window.close();
        //window["populateObjs"](false);
    }
}

async function deleteModel(id) {

    //DELETE MODEL
    const { error } = await supabase
        .from('3ds')
        .delete()
        .eq('id', id);

    // reload the current page

    window['toast']("Modelo Deletado com Sucesso!", "info")
    window.location.reload();

}

//--------------------------------------------------REGISTER BACKGROUNDS-----------------------------------------------------
async function registerAPI(data, bucketname, upsert, thumb) {

    window['stateLoadinScreen2'](true);

    var path; // Path in the bucket

    if (bucketname == "backgrounds")
        path = getUserId() + "/" + data.name + "_" + uuidv4();
    else if (bucketname == "3ds" || bucketname == "cliparts" || bucketname == "fonts")
        path = getUserId() + "/";
    else
        path = getUserId()

    var fonts = [];

    if (bucketname == "3ds") {

        const getExtension = file => file.name.split('.').pop().toLowerCase();

        const fileName = uuidv4();

        const files = [data.obj, data.svg]

        /*const { data: uploadData, error: uploadError } = await supabase.storage
                .from("images")
                .upload(path_id, fileSVGThumb, {
                    upsert: true, // Prevent overwriting existing files
                });

            const { data2, error2 } = await supabase
                .from('3ds')
                .update({ thumb2: path_id }) // Fields to update
                .eq('id', id) // Condition*/

        await Promise.all(files.map(file => {
            const extension = getExtension(file);
            return supabase
                .storage
                .from(bucketname)
                .upload(`${path}${fileName}.${extension}`, file);
        }));

        const { data: uploadData, error: uploadError } = await supabase.storage
            .from("images")
            .upload(fileName, thumb, {
                upsert: true, // Prevent overwriting existing files
            });

        if (data.thumbnail) {
            const { data: uploadData2, error: uploadError2 } = await supabase.storage
                .from("images")
                .upload(fileName + "-2", data.thumbnail, {
                    upsert: true, // Prevent overwriting existing files
                });
        }

        /*const { data2, error } = await supabase
            .from('3ds')
            .insert([
                {
                    name: data.name,
                    path: path + fileName,
                    user_id: getUserId(),
                    thumb2: fileName
                },
            ]).select()
            .single();*/

        var arrayTecidosNames = [];
        var arrayTecidosFiles = [];
        var arrayEscudosNames = [];
        var arrayEscudosFiles = [];
        var arrayTecidosPaths = [];
        var arrayEscudosPaths = [];

        for (var i = 0; i < data.tecidos.length; i++) {
            arrayTecidosNames.push(data.tecidos[i].nome);
            arrayTecidosFiles.push(data.tecidos[i].file);
        }

        for (var i = 0; i < data.escudos.length; i++) {
            arrayEscudosNames.push(data.escudos[i].nome);
            arrayEscudosFiles.push(data.escudos[i].file);
        }

        await Promise.all(
            arrayTecidosFiles.map((file, index) => {
                const extension = getExtension(file)

                const path = `${fileName}/${arrayTecidosNames[index] + Math.random()}.${extension}`

                arrayTecidosPaths.push({
                    [arrayTecidosNames[index]]: path
                })

                return supabase.storage
                    .from("tecidos")
                    .upload(
                        path,
                        file
                    )
            })
        )

        await Promise.all(
            arrayEscudosFiles.map((file, index) => {
                const extension = getExtension(file)

                const path = `${fileName}/${arrayEscudosNames[index] + Math.random()}.${extension}`

                arrayEscudosPaths.push({
                    [arrayEscudosNames[index]]: path
                })

                return supabase.storage
                    .from("escudos")
                    .upload(
                        path,
                        file
                    )
            })
        )

        const { data: data2, error: error2 } = await supabase
            .from("3ds")
            .insert([
                {
                    name: data.name,
                    path: path + fileName,
                    user_id: getUserId(),
                    thumb2: fileName,
                    category: data.category,
                    collar: data.collar,
                    desc: data.desc,
                    discount: data.discount,
                    price: data.price,
                    sizes: data.sizes,
                    sleeve: data.sleeve,
                    tecidos: JSON.stringify(arrayTecidosPaths),
                    escudos: JSON.stringify(arrayEscudosPaths)
                },
            ])
            .select()
            .single();

        window["populateObjs"](data2)
    } else if (bucketname == "cliparts" || bucketname == "fonts") {
        const files = data.image

        await Promise.all(
            files.map(file => {
                const name = path + uuidv4() + "_" + file.name;
                fonts.push(name);
                return supabase
                    .storage
                    .from(bucketname)
                    .upload(name, file);
            })
        );
    } else {
        const { data: uploadData3, error: uploadError3 } = await supabase.storage
            .from(bucketname)
            .upload(path, data.image, {
                upsert: upsert, // Prevent overwriting existing files
            });
    }

    if (bucketname == "backgrounds") {
        window['toast']("Fundo salvo! Você pode aplicar na tela de fundos do simulador.", "info")
        window["populateBackgrounds"]();
    } else if (bucketname == "cores") {
        window["populateColors"]();
        window['toast']("Tabela de cores Cadastrada! Para aplicar é necessário recarregar a página!", "info")
    } else if (bucketname == "cliparts") {
        window['toast']("CLiparts Cadastrados!", "info")
        window["loadCliparts"](true);
    } else if (bucketname == "fonts") {
        window['toast']("Fontes Cadastradas! Para aplicar é necessário recarregar a página!", "info")
        window["loadFontRegistered"](fonts);
    }

    window['stateLoadinScreen2'](false);
}

// Helper to extract file extension
function getFileExtension(filename) {
    const match = filename.match(/\.[0-9a-z]+$/i);
    return match ? match[0] : '';
}

async function getRegisteredAPI(bucketname, path) {
    const { data, error } = await supabase
        .storage
        .from(bucketname)
        .list(path, {
            limit: 100,      // Optional: max number of items
            offset: 0,       // Optional: for pagination
            sortBy: { column: 'name', order: 'asc' }  // Optional: sorting
        });

    if (error) {
        //console.error('Error fetching files:', error);
    } else {
        //console.log('Files:', data);
        return data
    }
}

// [NOTA] A antiga lista fixa de e-mails (SHARED_MODELAGENS_EMAILS) e a
// função getEffectiveModelagensUserId() foram removidas daqui. No lugar,
// usamos getOrgUserIds() (definida mais abaixo, na seção "ORGANIZAÇÃO"),
// que descobre dinamicamente quem compartilha a mesma organização (mesmo
// "email" em clients) — sem precisar editar código toda vez que alguém
// novo entra na equipe.

async function getRegisteredObjs() {
    const myId = getUserId();
    const orgIds = await getOrgUserIds(myId);
    let { data: objs, error } = await supabase
        .from('3ds')
        .select('*')
        .in('user_id', orgIds)
        .is('setup_data', null)

    return objs;
}

async function saveRegisteredObjThumb(id) {

    let { data, error } = await supabase
        .from('3ds')
        .select('*')
        .eq('id', id)

    if (data) {
        if (!data[0].thumb2) {

            const path_id = uuidv4(); // Path in the bucket

            //SVG THUMB FILE
            const urlObjThumb2 = document.getElementById("viewer-3d").toDataURL("image/webp");
            const linkObjThumb2 = document.createElement("a");
            linkObjThumb2.href = urlObjThumb2;
            linkObjThumb2.download = "image.webp";
            //linkObjThumb2.click();

            let responseObjThumb2 = await fetch(linkObjThumb2);
            let dataObjThumb2 = await responseObjThumb2.blob();
            let metadataObjThumb2 = {
                type: "image/jpeg",
            };
            let fileSVGThumb = new File([dataObjThumb2], "teste.jpeg", metadataObjThumb2);

            const { data: uploadData, error: uploadError } = await supabase.storage
                .from("images")
                .upload(path_id, fileSVGThumb, {
                    upsert: true, // Prevent overwriting existing files
                });

            const { data2, error2 } = await supabase
                .from('3ds')
                .update({ thumb2: path_id }) // Fields to update
                .eq('id', id) // Condition
        }
    }

}

async function deleteRegisteredObj(id, path) {

    let { data: data0, error0 } = await supabase
        .from('clients')
        .select()
        .eq('client_id', getUserId())

    if (data0[0].model_start == "https://nfghuenhuaecfyccyaib.supabase.co/storage/v1/object/public/3ds/" + path) {
        window['toast']("Modelo não pode ser deletado pois é o padrão!", "info")
        return false;
    } else {
        const { data, error } = await supabase
            .storage
            .from("3ds")
            .remove([path]);

        const { data2, error2 } = await supabase
            .storage
            .from("3ds")
            .remove([path.replace(".glb", ".svg")]);

        const { error3 } = await supabase
            .from('3ds')
            .delete()
            .eq('id', id);

        return true;
    }
}

async function editRegisteredObj(id) {


}

//--------------------------------------------------------------------

async function deleteRegisteredAPI(path, bucketname) {
    const { data, error } = await supabase
        .storage
        .from(bucketname)
        .remove([path]);

    if (error) {
        //console.error('Error deleting file:', error);
    } else {
        //console.log('File deleted:', data);
    }
}

async function registerClient(logo, name, description, phone, banner_print_top, banner_print_bottom, catalog_banner_top, email, end, cnpj, site,
    instagram, whatsapp, horario, pedido_min, prazo, pagamento, role, user_name) {

    try {
    window['stateLoadinScreen2'](true);

    if (catalog_banner_top) {
        const { data: uploadData, error: uploadError } = await supabase.storage
            .from("images")
            .upload(getUserId() + "_catalog_banner_top", catalog_banner_top, {
                upsert: true,
            });
        if (uploadError) console.error("[registerClient] catalog_banner_top upload error:", uploadError);
    }

    if (logo) {
        const { data: uploadData, error: uploadError } = await supabase.storage
            .from("images")
            .upload(getUserId() + "_logo", logo, {
                upsert: true,
            });
        if (uploadError) console.error("[registerClient] logo upload error:", uploadError);
    }

    if (window.clientSaved) {
        const { data, error } = await supabase
            .from('clients')
            .update({
                name: name, description: description, phone: phone, email: email, address: end, cnpj: cnpj, site: site, instagram: instagram,
                whatsapp: whatsapp, horario: horario, pedido_min: pedido_min, prazo: prazo, pagamento: pagamento, role: role || null,
                user_name: user_name || null
            })
            .eq('client_id', getUserId())

        if (error) {
            console.error("[registerClient] update error:", error)
            window['toast']("Erro ao tentar salvar, tente novamente!", "error")
        } else {
            window['toast']("Salvo com sucesso!", "info")
        }
        cacheInvalidate(`client:${getUserId()}`)
        window['stateLoadinScreen2'](false);
    } else {
        const payload = {
            name: localStorage.getItem("user_name"),
            description: description,
            phone: phone,
            client_id: getUserId(),
            email: localStorage.getItem("user_email"),
            address: end,
            cnpj: cnpj,
            site: site,
            instagram: instagram,
            whatsapp: whatsapp,
            horario: horario,
            pedido_min: pedido_min,
            prazo: prazo,
            pagamento: pagamento,
            role: role || null,
            user_name: user_name || null
        };

        let { data, error } = await supabase
            .from('clients')
            .upsert([payload], { onConflict: 'client_id' });

        // 42P10: a tabela clients não tem constraint unique em client_id,
        // então ON CONFLICT não é suportado. Fallback p/ insert simples —
        // sem isso contas novas nunca eram criadas e o editor crashava em
        // client[0].model_start (getProjects/populateObjs).
        if (error && error.code === '42P10') {
            console.warn("[registerClient] upsert sem constraint (42P10), tentando insert simples…");
            const res = await supabase.from('clients').insert([payload]).select();
            error = res.error;
            data = res.data;
        }

        if (error) {
            console.error("[registerClient] upsert error:", error)
            window['toast']("Erro ao tentar salvar, tente novamente!", "error")
    } else {
        window.clientSaved = true;
            window['toast']("Salvo com sucesso!", "info")
        }
        cacheInvalidate(`client:${getUserId()}`)
        window['stateLoadinScreen2'](false);
    }
    } catch (e) {
        console.error("[registerClient] exception:", e);
        window['toast']("Erro ao tentar salvar, tente novamente!", "error");
        window['stateLoadinScreen2'](false);
    }
}

async function getClient(id) {
    const cacheKey = `client:${id}`
    const cached = cacheGet(cacheKey, 30000)
    if (cached) return cached

    const data = await dedupedQuery(cacheKey, async () => {
        let { data: client, error } = await supabase
            .from('clients')
            .select('id, client_id, name, description, phone, email, address, cnpj, site, instagram, whatsapp, horario, pedido_min, prazo, pagamento, role, user_name, background, model_start, simulator_models')
            .eq('client_id', id)
        return client
    })

    if (data) cacheSet(cacheKey, data)
    return data;
}

// Helper: adiciona timeout a uma promise
function withTimeout(promise, ms, label = '') {
    return Promise.race([
        promise,
        new Promise((_, reject) =>
            setTimeout(() => reject(new Error(`Timeout ${label} (${ms}ms)`)), ms)
        ),
    ])
}

// Busca todas as categorias compartilhadas (apenas colunas necessárias)
// Cache de 5min porque categorias raramente mudam
export async function getAllCategoriesLight() {
    const cacheKey = `mgr:all:categories_new:light`
    const cached = cacheGet(cacheKey, 300000) // 5 min
    if (cached) { return cached }

    const _t = performance.now()
    try {
        const { data, error } = await withTimeout(
            supabase
                .from('categories_new')
                .select('category_id, json'),
            15000,
            'categories_new'
        )

        if (error) {
            console.error("[PERF-PROJECTS] getAllCategoriesLight error:", error)
            return [];
        }

        if (data) cacheSet(cacheKey, data)
        return data || [];
    } catch (err) {
        console.warn(`[PERF-PROJECTS] getAllCategoriesLight: ${err.message} (${(performance.now() - _t).toFixed(0)}ms)`)
        return [];
    }
}

export async function getClients() {
    const _t = performance.now()
    let { data: client2, error } = await supabase
        .from('clients')
        .select('client_id, name')

    return client2;
}

export async function getClient2(id) {

    let { data: client, error } = await supabase
        .from('clients')
        .select('*')
        .eq('id', id)

    return client;
}

//REGISTER IMAGES 

async function registerImages(image, id) {

    const { data, error } = await supabase
        .from('Images')
        .insert([
            {
                image: image,
                model_id: id
            },
        ]);

    window['toast']("Imagem Salva!", "info")
}

async function getImages(id) {
    const cacheKey = `simulator:img:${id}`
    const cached = cacheGet(cacheKey, 30000)
    if (cached) return cached

    let { data: images, error } = await supabase
        .from('simulator')
        .select('id, user_id, images, inside_color, body_state, socks_state, up_state, down_state, clone_state, up_state2, collar')
        .eq('id', id)

    if (images) cacheSet(cacheKey, images)
    return images;
}

async function deleteImage(id) {

    const { error } = await supabase
        .from('Images')
        .delete()
        .eq('id', id);
}

//REGISTER CATALOG

async function registerCatalog(list, name) {

    const { data, error } = await supabase
        .from('catalagos')
        .insert([
            {
                list: list,
                name: name,
                user_id: getUserId()
            },
        ]);

    window['toast']("Catalogo Salvos! Necessário Regarregar página para adicionar items no catálogo!", "info")
}

async function getCatalogs(id) {

    let { data: catalogos, error } = await supabase
        .from('catalagos')
        .select('*')
        .eq('user_id', getUserId())

    return catalogos;
}

async function getCatalog(id) {

    let { data: catalogos, error } = await supabase
        .from('catalagos')
        .select('*')
        .eq('id', id)

    return catalogos;
}

async function deleteCatalog(id) {

    const { error } = await supabase
        .from('catalagos')
        .delete()
        .eq('id', id);
}

async function editCatalog(id, list) {

    const { data, error } = await supabase
        .from('catalagos')
        .update({ list }) // Fields to update
        .eq('id', id) // Condition
}

async function getProject(id) {
    const cacheKey = `simulator:proj:${id}`
    const cached = cacheGet(cacheKey, 30000)
    if (cached) return cached

    let { data: project, error } = await supabase
        .from('simulator')
        .select('*')
        .eq('id', id)

    if (project) cacheSet(cacheKey, project)
    return project;
}

//----------------------------------------------------------------------------------------------------------------------------

async function registerCategory(data) {
    window['stateLoadinScreen2'](true);

    const { data: newCategory, error } = await supabase
        .from('categories')
        .insert([
            {
                name: data.name,
                user_id: getUserId(),
            }
        ])
        .select()
        .single(); // 👈 força retornar só 1 objeto

    window['stateLoadinScreen2'](false);

    if (error) {
        //console.log(error)
        window['toast']("Erro ao tentar salvar, tente novamente!", "info")
    } else {
        return newCategory.id.toString()
    }
}


async function getCategories(id) {

    let { data: categories, error } = await supabase
        .from('categories')
        .select('*')
        .eq('user_id', getUserId())

    return categories;
}

async function editCategory(id, name) {

    const { data, error } = await supabase
        .from('categories')
        .update({ name: name }) // Fields to update
        .eq('id', id) // Condition
}

async function deleteCategory(id) {

    const { error } = await supabase
        .from('categories')
        .delete()
        .eq('id', id);
}

async function dataURLtoFile(dataUrl, filename) {
    return new Promise((resolve, reject) => {
        try {
            const arr = dataUrl.split(',');
            const mime = arr[0].match(/:(.*?);/)?.[1] || '';
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);

            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }

            resolve(new File([u8arr], filename, { type: mime }));
        } catch (err) {
            reject(err);
        }
    });
}

async function registerKit(data) {

    window['stateLoadinScreen2'](true);

    const path_id = getUserId() + "/" + uuidv4(); // Path in the bucket

    const thumb = await dataURLtoFile(data.thumb, "image.png");

    const { data: uploadData, error: uploadError } = await supabase.storage
        .from("images")
        .upload(path_id, thumb, {
            upsert: false, // Prevent overwriting existing files
        });

    const { data2, error } = await supabase
        .from('kits')
        .insert([
            {
                name: data.name,
                user_id: getUserId(),
                price1: data.price1,
                price2: data.price2,
                price3: data.price3,
                desc: data.description,
                thumb: path_id,
                features: JSON.stringify(data.features),
                category_id: data.categoryId
            },
        ]);

    window['stateLoadinScreen2'](false);

    if (error) {
        //console.log(error)
        window['toast']("Erro ao tentar salvar, tente novamente!", "info")
    }
}

async function editKit(kit, id) {

    if (kit.thumb.includes("data:image")) {
        const thumb = await dataURLtoFile(kit.thumb, "image.png");

        const { data: uploadData, error: uploadError } = await supabase.storage
            .from("images")
            .upload(kit.path, thumb, {
                upsert: true, // Prevent overwriting existing files
            });
    }

    const { data, error } = await supabase
        .from('kits')
        .update({
            name: kit.name,
            price1: kit.price1,
            price2: kit.price2,
            price3: kit.price3,
            desc: kit.description,
            features: JSON.stringify(kit.features)
        }) // Fields to update
        .eq('id', id) // Condition
}

async function deleteKit(id) {

    const { error } = await supabase
        .from('kits')
        .delete()
        .eq('id', id);
}

async function getKits(name, id) {

    let { data: kits, error } = await supabase
        .from('kits')
        .select('*')
        .eq(name, id)

    return kits;
}

//

async function registerSeller(data) {

    window['stateLoadinScreen2'](true);

    const path_id = getUserId() + "/" + uuidv4(); // Path in the bucket

    // Passo 1: salva o obj  no storage do supabase
    const { data: uploadData, error: uploadError } = await supabase.storage
        .from("images")
        .upload(path_id, data.photo2, {
            upsert: true, // Prevent overwriting existing files
        });

    const { data2, error } = await supabase
        .from('vendedores')
        .insert([
            {
                name: data.name,
                user_id: getUserId(),
                thumb: path_id,
                phone: data.phone
            },
        ]);

    window['stateLoadinScreen2'](false);

    if (error) {
        //console.log(error)
        window['toast']("Erro ao tentar salvar, tente novamente!", "info")
    }
}

async function getSellers(id) {
    let { data: sellers, error } = await supabase
        .from('vendedores')
        .select('*')
        .eq('user_id', id)

    return sellers;
}

async function deleteSeller(id) {
    const { error } = await supabase
        .from('vendedores')
        .delete()
        .eq('id', id);
}

//
async function registerProjectIframe(data2, user_id, svg_json, thumb, file_svg, sport, order, backThumb) {

    window['stateLoadinScreen'](true);

    // Usa o user_id do DONO do catálogo (passado explicitamente), não o
    // localStorage — quem está enviando o pedido pelo link compartilhado
    // pode não ser o dono, e o path precisa continuar organizado por dono.
    const path_id = user_id + "/" + uuidv4(); // Path in the bucket

    const thumbFile = await dataURLtoFile(thumb, "image.png");

    const { data: uploadData3, error: uploadError3 } = await supabase.storage
        .from("svgs-json")
        .upload(path_id, svg_json, {
            upsert: false, // Prevent overwriting existing files
        });

    const { data: uploadData5, error: uploadError5 } = await supabase.storage
        .from("svgs")
        .upload(path_id, file_svg, {
            upsert: false, // Prevent overwriting existing files
            contentType: "image/svg+xml", // Sem isso, o Supabase grava como text/plain e o
            // editor.js (que checa esse content-type pra decidir se descomprime com
            // pako.ungzip) tenta descomprimir um SVG puro e trava a tela de loading.
        });

    const { data: uploadData4, error: uploadError4 } = await supabase.storage
        .from("images")
        .upload(path_id, thumbFile, {
            upsert: false, // Prevent overwriting existing files
        });

    // Foto de costas (opcional) — mesma pasta, sufixo "-back". Não precisa de
    // coluna nova na tabela: o PDF simplesmente tenta buscar esse caminho
    // derivado, e ignora de boa se não existir (pedidos antigos, por ex).
    if (backThumb) {
        try {
            const backFile = await dataURLtoFile(backThumb, "image-back.png");
            await supabase.storage
                .from("images")
                .upload(path_id + "-back", backFile, { upsert: false });
        } catch (e) {
            console.error('Erro ao salvar foto de costas:', e);
        }
    }

    /*const { data2, error } = await supabase
        .from('iframe_projects')
        .insert([
            {
                user_id: user_id,
                thumb: path_id,
                json: path_id,
                svg: path_id,
                data: JSON.stringify(data)
            },
        ]).select();*/

    // A coluna "order" não é mais usada pro breakdown antigo de peças —
    // reaproveitada agora pra guardar o status do pedido no Kanban (ver
    // updateProjectIframeStatus). Se quem chamou não passou status, começa
    // como "novo".
    const orderWithStatus = { status: "novo", ...(order || {}) };

    const { data, error } = await supabase
        .from('iframe_projects')
        .insert([
            {
                user_id: user_id,
                thumb: path_id,
                json: path_id,
                svg: path_id,
                data: JSON.stringify(data2),
                sport: sport,
                order: JSON.stringify(orderWithStatus)
            },
        ])
        .select();

    window['stateLoadinScreen'](false);

    if (data) {
        return data[0];
    } else {
        //console.log(error)
    }

}

// Atualiza só o status do pedido (Kanban: novo, revisão, produção,
// enviado pro vendedor, concluído). Guardado dentro da coluna "order".
export async function updateProjectIframeStatus(id, status) {
    const { data, error } = await supabase
        .from('iframe_projects')
        .update({ order: JSON.stringify({ status }) })
        .eq('id', id)
        .select();

    if (error) {
        console.error('Erro ao atualizar status do pedido:', error);
        return null;
    }

    return data?.[0] ?? null;
}

// ── Colunas do Kanban de "Pedidos do Iframe" — cada loja tem as suas,
// pode adicionar/renomear/excluir livremente (tabela iframe_kanban_columns).

const DEFAULT_KANBAN_COLUMNS = [
    { status_id: "novo",      label: "Novos Pedidos",       color: "#e94560", position: 0 },
    { status_id: "aprovado",  label: "Aprovado",            color: "#16a34a", position: 1 },
    { status_id: "revisao",   label: "Em Revisão",          color: "#f59e0b", position: 2 },
    { status_id: "producao",  label: "Em Produção",         color: "#3b82f6", position: 3 },
    { status_id: "vendedor",  label: "Enviado p/ Vendedor", color: "#8b5cf6", position: 4 },
    { status_id: "concluido", label: "Concluído",           color: "#22c55e", position: 5 },
];

// Conta quantos pedidos do iframe chegaram depois de um determinado momento
// — usado pro balão de notificação em cima do botão "Pedidos do Iframe".
export async function countNewIframeOrders(ownerId, sinceIso) {
    let query = supabase
        .from('iframe_projects')
        .select('id', { count: 'exact', head: true })
        .eq('user_id', ownerId);

    if (sinceIso) {
        query = query.gt('created_at', sinceIso);
    }

    const { count, error } = await query;

    if (error) {
        console.error('Erro ao contar novos pedidos do iframe:', error);
        return 0;
    }

    return count || 0;
}

// ── Progresso salvo pelo cliente no iframe (antes de fechar o pedido) ──────
// Salva o mapa (SVG aplicado na UV) + thumbnail nos mesmos buckets já usados
// pra pedidos, e grava/atualiza uma linha em iframe_saved_progress. Se
// "existingId" for passado, atualiza a mesma linha (evita duplicar a cada
// clique em "Salvar" enquanto o cliente ainda está decidindo o layout).
export async function saveIframeProgress(ownerId, sportId, thumbDataUrl, svgString, existingId) {
    try {
        const path_id = ownerId + "/" + uuidv4();

        const thumbFile = await dataURLtoFile(thumbDataUrl, "image.png");
        const { error: thumbError } = await supabase.storage
            .from("images")
            .upload(path_id, thumbFile, { upsert: true, contentType: "image/png" });
        if (thumbError) console.error('Erro ao salvar thumbnail do progresso:', thumbError);

        const svgBlob = new Blob([svgString || ""], { type: "image/svg+xml" });
        const { error: svgError } = await supabase.storage
            .from("svgs")
            .upload(path_id, svgBlob, { upsert: true, contentType: "image/svg+xml" });
        if (svgError) console.error('Erro ao salvar mapa do progresso:', svgError);

        if (existingId) {
            const { data, error } = await supabase
                .from('iframe_saved_progress')
                .update({
                    sport_id: sportId,
                    svg: path_id,
                    thumb: path_id,
                    updated_at: new Date().toISOString(),
                })
                .eq('id', existingId)
                .select();

            if (error) { console.error('Erro ao atualizar progresso salvo:', error); return null; }
            return data?.[0] ?? null;
        }

        const { data, error } = await supabase
            .from('iframe_saved_progress')
            .insert([{ owner_id: ownerId, sport_id: sportId, svg: path_id, thumb: path_id }])
            .select();

        if (error) { console.error('Erro ao salvar progresso:', error); return null; }
        return data?.[0] ?? null;
    } catch (e) {
        console.error('Erro inesperado ao salvar progresso:', e);
        return null;
    }
}

export async function getIframeProgress(id) {
    const { data, error } = await supabase
        .from('iframe_saved_progress')
        .select('*')
        .eq('id', id);

    if (error) {
        console.error('Erro ao buscar progresso salvo:', error);
        return null;
    }

    return data?.[0] ?? null;
}

// ── Comprovante de aceite/aprovação de arte ─────────────────────────────────

export async function saveApproval(payload) {
    const { data, error } = await supabase
        .from('iframe_approvals')
        .insert([{
            owner_id: payload.ownerId,
            iframe_options_id: payload.iframeOptionsId ?? null,
            project_id: payload.projectId ?? null,
            client_name: payload.clientName,
            client_email: payload.clientEmail ?? null,
            message: payload.message,
            signature_data_url: payload.signatureDataUrl,
            order_list: payload.orderList ?? null,
            ip_address: payload.ipAddress ?? null,
            device_info: payload.deviceInfo ?? null,
        }])
        .select();

    if (error) {
        console.error('Erro ao salvar comprovante de aceite:', error);
        return null;
    }

    const approval = data?.[0] ?? null;

    // Tenta vincular/criar pedido em iframe_projects
    if (payload.projectId && payload.ownerId && payload.clientName) {
        try {
            // Busca pedido existente para este modelo (sport) e cliente
            const { data: existingOrders } = await supabase
                .from('iframe_projects')
                .select('id, order, sport, data')
                .eq('user_id', payload.ownerId)
                .eq('sport', payload.projectId)
                .order('created_at', { ascending: false });

            let targetOrderId = null;
            let existingOrderData = null;

            if (existingOrders && existingOrders.length > 0) {
                // Procura pelo cliente (nome/email) nos dados do pedido
                for (const order of existingOrders) {
                    try {
                        const orderData = order.data ? JSON.parse(order.data) : {};
                        if (orderData.name?.toLowerCase() === payload.clientName.toLowerCase() ||
                            orderData.email?.toLowerCase() === payload.clientEmail?.toLowerCase()) {
                            targetOrderId = order.id;
                            existingOrderData = order;
                            break;
                        }
                    } catch (e) {}
                }
            }

            // Se não encontrou, pega o mais recente do modelo
            if (!targetOrderId && existingOrders && existingOrders.length > 0) {
                targetOrderId = existingOrders[0].id;
                existingOrderData = existingOrders[0];
            }

            // Prepara thumb (se foi passado) - upload para storage
            let thumbPath = null;
            if (payload.thumbDataUrl) {
                const path_id = payload.ownerId + "/" + (approval?.id || Date.now().toString(36) + Math.random().toString(36).slice(2));
                const thumbFile = await dataURLtoFile(payload.thumbDataUrl, "thumb.png");
                const { error: thumbError } = await supabase.storage
                    .from("images")
                    .upload(path_id, thumbFile, { upsert: true, contentType: "image/png" });
                if (!thumbError) {
                    thumbPath = path_id;
                }
            }

            if (targetOrderId) {
                // Atualiza pedido existente
                const currentOrder = existingOrderData?.order ? JSON.parse(existingOrderData.order) : {};
                const updateData = { 
                    order: JSON.stringify({ 
                        ...currentOrder, 
                        status: "aprovado",
                        approved: true, 
                        approved_at: new Date().toISOString(),
                        approval_id: approval?.id 
                    }) 
                };
                if (thumbPath) updateData.thumb = thumbPath;
                await supabase
                    .from('iframe_projects')
                    .update(updateData)
                    .eq('id', targetOrderId);
            } else {
                // Cria novo pedido básico na aprovação
                const path_id = payload.ownerId + "/" + (approval?.id || Date.now().toString(36) + Math.random().toString(36).slice(2));
                
                const orderData = {
                    name: payload.clientName,
                    email: payload.clientEmail || "",
                    phone: "",
                    address: "",
                    comments: "Aprovado via link de aprovação",
                    list: "",
                    purposes: [],
                    date: new Date().toISOString().split('T')[0],
                };

                const orderWithStatus = { status: "aprovado", ...orderData, approved: true, approved_at: new Date().toISOString(), approval_id: approval?.id };

                const insertData = {
                    user_id: payload.ownerId,
                    json: path_id,
                    svg: path_id,
                    data: JSON.stringify(orderData),
                    sport: payload.projectId,
                    order: JSON.stringify(orderWithStatus)
                };
                if (thumbPath) insertData.thumb = thumbPath;

                await supabase
                    .from('iframe_projects')
                    .insert([insertData]);
            }
        } catch (e) {
            console.error('Erro ao sincronizar aprovação com pedido:', e);
        }
    }

    return approval;
}

// Usado só pra exibir no comprovante ("IP de Registro") — não é usado pra
// nenhuma validação de segurança, é só informativo.
export async function getClientPublicIP() {
    try {
        const res = await fetch('https://api.ipify.org?format=json');
        const data = await res.json();
        return data?.ip ?? null;
    } catch (e) {
        console.error('Erro ao buscar IP público:', e);
        return null;
    }
}

export async function getKanbanColumns(ownerId) {

    const { data, error } = await supabase
        .from('iframe_kanban_columns')
        .select('*')
        .eq('user_id', ownerId)
        .order('position', { ascending: true });

    if (error) {
        console.error('Erro ao buscar colunas do Kanban:', error);
        return [];
    }

    // Primeira vez que essa loja abre a tela: já popula com as colunas
    // padrão, pra não começar vazio.
    if (!data || data.length === 0) {
        const seeded = DEFAULT_KANBAN_COLUMNS.map(c => ({ ...c, user_id: ownerId }));
        const { data: inserted, error: seedError } = await supabase
            .from('iframe_kanban_columns')
            .insert(seeded)
            .select();

        if (seedError) {
            console.error('Erro ao criar colunas padrão do Kanban:', seedError);
            // Mesmo sem conseguir salvar, devolve as padrão pra tela não ficar vazia.
            return DEFAULT_KANBAN_COLUMNS.map((c, i) => ({ ...c, id: `default-${i}`, user_id: ownerId }));
        }

        return inserted || [];
    }

    // Garante que a coluna "Aprovado" existe — usuários antigos não tinham.
    if (data && data.length > 0 && !data.some(c => c.status_id === "aprovado")) {
        const maxPos = Math.max(...data.map(c => c.position ?? 0));
        const aprovadoCol = { status_id: "aprovado", label: "Aprovado", color: "#16a34a", position: maxPos + 1 };
        const { data: inserted, error: insertErr } = await supabase
            .from('iframe_kanban_columns')
            .insert({ ...aprovadoCol, user_id: ownerId })
            .select();
        if (!insertErr && inserted?.[0]) {
            data.push(inserted[0]);
        }
    }

    return data;
}

export async function addKanbanColumn(ownerId, label, color, position) {
    const status_id = 'col-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);

    const { data, error } = await supabase
        .from('iframe_kanban_columns')
        .insert([{ user_id: ownerId, status_id, label, color: color || '#94a3b8', position }])
        .select();

    if (error) {
        console.error('Erro ao adicionar coluna do Kanban:', error);
        return null;
    }

    return data?.[0] ?? null;
}

export async function renameKanbanColumn(id, label) {
    const { data, error } = await supabase
        .from('iframe_kanban_columns')
        .update({ label })
        .eq('id', id)
        .select();

    if (error) {
        console.error('Erro ao renomear coluna do Kanban:', error);
        return null;
    }

    return data?.[0] ?? null;
}

export async function deleteKanbanColumn(id) {
    const { error } = await supabase
        .from('iframe_kanban_columns')
        .delete()
        .eq('id', id);

    if (error) {
        console.error('Erro ao excluir coluna do Kanban:', error);
        return false;
    }

    return true;
}

async function getProjectsIframe(ownerId) {
    let { data: projects, error } = await supabase
        .from('iframe_projects')
        .select('*')
        .eq('user_id', ownerId || getUserId())
        .order('created_at', { ascending: false })

    return projects;
}

async function deleteProjectIframe(id) {
    const { error } = await supabase
        .from('iframe_projects')
        .delete()
        .eq('id', id);
}

async function editProject(id, name, svg, svg_thumb, svg_json, fileSvgImage, annotations, fabrics) {

    window['stateLoadinScreen2'](true);

    let { data: project, errorP } = await supabase
        .from('simulator')
        .select()
        .eq('id', id);

    // Passo 1: salva o svg no storage do supabase
    const { data: uploadData, error: uploadError } = await supabase.storage
        .from("svgs")
        .upload(project[0].svg_path, svg, {
            upsert: true, // Prevent overwriting existing files
        });

    if (uploadError) {
        //console.log(uploadError)
        window['toast']("Erro ao tentar salvar, tente novamente!", "info")
        return
    }

    // Passo 2: salva o svg no storage do supabase
    const { data: uploadData2, error: uploadError2 } = await supabase.storage
        .from("svgs-thumbs")
        .upload(project[0].svg_path, svg_thumb, {
            upsert: true, // Prevent overwriting existing files
        });

    if (uploadError2) {
        //console.log(uploadError2)
        window['toast']("Erro ao tentar salvar, tente novamente!", "info")
        return
    }

    // Passo 3: salva o svg como json no storage do supabase
    /*const { data: uploadData3, error: uploadError3 } = await supabase.storage
        .from("svgs-json")
        .upload(project[0].svg_path, svg_json, {
            upsert: true, // Prevent overwriting existing files
        });

    if (uploadError3) {
        alert("Erro ao tentar salvar, tente novamente!")
        return
    }*/

    // Passo 4: salva o svg como json no storage do supabase
    const { data: uploadData4, error: uploadError4 } = await supabase.storage
        .from("images")
        .upload(project[0].svg_path, fileSvgImage, {
            upsert: true, // Prevent overwriting existing files
        });

    if (window.roughnessMapFile) {
        const { data: uploadData5, error: uploadError5 } = await supabase.storage
            .from("images")
            .upload(project[0].svg_path + "_relevo", window.roughnessMapFile, {
                upsert: true, // Prevent overwriting existing files
            });
    }

    if (uploadError4) {
        //console.log(uploadError4)
        window['toast']("Erro ao tentar salvar, tente novamente!", "info")
        return
    }

    var pathAno = project[0].svg_path;

    if (annotations) {
        const fileAnnotations = new Blob([annotations], { type: "application/json" });

        const { data: uploadData5, error: uploadError5 } = await supabase.storage
            .from("jsons")
            .upload(project[0].svg_path, fileAnnotations, {
                upsert: true, // Prevent overwriting existing files
            });
    } else {
        pathAno = null;
    }

    const body_state = $("#state-body-ra").attr("data-state") === "checked";
    const socks_state = $("#state-socks-ra").attr("data-state") === "checked";
    const up_state = $("#state-shirt-ra").attr("data-state") === "checked";
    const down_state = $("#state-short-ra").attr("data-state") === "checked";
    const clone_state = $("#state-clone").attr("data-state") === "checked";
    const up_state2 = $("#state-shirt2-ra").attr("data-state") === "checked";

    const { data, error } = await supabase
        .from('simulator')
        .update({
            name: name,
            body_state: body_state,
            socks_state: socks_state,
            up_state: up_state,
            up_state2: up_state2,
            down_state: down_state,
            clone_state: clone_state,
            inside_color: window.insideModelColor,
            collar: window.selected_collar,
            annotations: pathAno,
            fabrics: JSON.stringify(fabrics),
            relevo: JSON.stringify(window.relevo),
            productionOrder: window.editProjectMeta?.productionOrder ?? undefined,
            file_path: window.editProjectMeta?.filePath ?? undefined,
        }) // Fields to update
        .eq('id', id) // Condition

    /*//Passo 3: Salva tudo na tabela
    const { data, error } = await supabase
        .from('simulator')
        .insert([
            {
                background: background,
                material: material,
            },
        ]).select(); // 👈 faz retornar o registro inserido*/

    if (error) {
        window['toast']("Erro!", "info")
    } else {
        cacheInvalidate("simulator")
        window['toast']("Projeto Editado com sucesso!", "info")
    }
    window['stateLoadinScreen2'](false);
}

async function updateProjectMetadata(id, data) {
    const { error } = await supabase
        .from('simulator')
        .update({
            name: data.projectName,
            designer: data.designer,
            productionOrder: data.productionOrder,
            file_path: data.filePath || null,
        })
        .eq('id', id);

    if (error) {
        window['toast']("Erro ao editar projeto!", "error");
        return false;
    }
    cacheInvalidate("simulator");
    window['toast']("Projeto editado com sucesso!", "info");
    return true;
}

window["updateProjectMetadata"] = updateProjectMetadata;

async function updateClientBackground(path) {
    const { data, error } = await supabase
        .from('clients')
        .update({
            background: path
        }) // Fields to update
        .eq('client_id', getUserId()) // Condition

    if (error) {

    } else {

        if (path)
            window['toast']("Esse é seu novo fundo padrão para o iframe!", "info")
        else
            window['toast']("Fundo iframe resetado!", "info")
    }
}

async function registerPresets(sport_id, transforms, transforms_clone, camera, fabric, fabric_repeat, cover, fabrics) {

    const spotParams = [];

    spotParams.spot_pos = window.spotLightMain.position;
    spotParams.target_pos = window.spotLightMain.target.position;

    const spotParamsJSON = JSON.stringify(spotParams);

    let { data: data0, error0 } = await supabase
        .from('presets')
        .select()
        .eq('user_id', getUserId())
        .eq('sport_id', sport_id)

    var back;

    if ($("#background-panel").css("background-image").includes("url")) {
        back = $("#background-panel").css("background-image");
    } else {
        back = $("#background-panel").css("background");
    }

    const body_state = $("#state-body-ra").attr("data-state") === "checked";
    const socks_state = $("#state-socks-ra").attr("data-state") === "checked";
    const up_state = $("#state-shirt-ra").attr("data-state") === "checked";
    const down_state = $("#state-short-ra").attr("data-state") === "checked";
    const clone_state = $("#state-clone").attr("data-state") === "checked";

    const up_state2 = $("#state-shirt2-ra").attr("data-state") === "checked";

    if (data0[0]) {

        const { data, error } = await supabase
            .from('presets')
            .update({
                state_avatar: body_state,
                state_socks: socks_state,
                state_shirt: up_state,
                state_shirt2: up_state2,
                state_short: down_state,
                state_clone: clone_state,
                camera: camera,
                transforms: transforms,
                transforms_clone: transforms_clone,
                background: back,
                /*fabric: fabric,
                fabric_repeat: fabric_repeat,*/
                spot_state: spotParamsJSON,
                collar: window.selected_collar,
                back_cover: cover,
                fabrics: JSON.stringify(fabrics)
            }) // Fields to update
            .eq('id', data0[0].id) // Condition

        if (error) {
            //console.log(error)
            window['toast']("Erro ao tentar salvar, tente novamente!", "info")
        } else {
            window['toast']("Predefinições Salvas!", "info")
        }

    } else {
        const { data, error } = await supabase
            .from('presets')
            .insert([
                {
                    user_id: getUserId(),
                    sport_id: sport_id,
                    state_avatar: body_state,
                    state_socks: socks_state,
                    state_shirt: up_state,
                    state_shirt2: up_state2,
                    state_short: down_state,
                    state_clone: clone_state,
                    camera: camera,
                    transforms: transforms,
                    transforms_clone: transforms_clone,
                    background: back,
                    /*fabric: fabric,
                    fabric_repeat: fabric_repeat,*/
                    spot_state: spotParamsJSON,
                    collar: window.selected_collar,
                    back_cover: cover,
                    fabrics: JSON.stringify(fabrics)
                },
            ]);

        if (error) {
            //console.log(error)
            window['toast']("Erro ao tentar salvar, tente novamente!", "info")
        } else {
            window['toast']("Predefinições Salvas!", "info")
        }
    }

}

async function saveFabricPreset(sport_id, fabrics) {
    let { data: data0 } = await supabase
        .from('presets')
        .select('id')
        .eq('user_id', getUserId())
        .eq('sport_id', sport_id)

    const fabricsJSON = JSON.stringify(fabrics);

    if (data0 && data0[0]) {
        const { error } = await supabase
            .from('presets')
            .update({ fabrics: fabricsJSON })
            .eq('id', data0[0].id)

        if (error) {
            window['toast']("Erro ao salvar preset de tecido!", "info")
        } else {
            window['toast']("Preset de tecido salvo!", "info")
        }
    } else {
        const { error } = await supabase
            .from('presets')
            .insert([{
                user_id: getUserId(),
                sport_id: sport_id,
                fabrics: fabricsJSON
            }])

        if (error) {
            window['toast']("Erro ao salvar preset de tecido!", "info")
        } else {
            window['toast']("Preset de tecido salvo!", "info")
        }
    }
}

async function saveAnnotationPreset(sport_id, annotations) {
    let { data: data0 } = await supabase
        .from('presets')
        .select('id')
        .eq('user_id', getUserId())
        .eq('sport_id', sport_id)

    const annotationsJSON = JSON.stringify(annotations);

    if (data0 && data0[0]) {
        const { error } = await supabase
            .from('presets')
            .update({ annotations: annotationsJSON })
            .eq('id', data0[0].id)

        if (error) {
            window['toast']("Erro ao salvar anotações!", "info")
        } else {
            window['toast']("Anotações salvas!", "info")
        }
    } else {
        const { error } = await supabase
            .from('presets')
            .insert([{
                user_id: getUserId(),
                sport_id: sport_id,
                annotations: annotationsJSON
            }])

        if (error) {
            window['toast']("Erro ao salvar anotações!", "info")
        } else {
            window['toast']("Anotações salvas!", "info")
        }
    }
}

async function getPresets(sport_id, user_id) {

    let { data: data0, error0 } = await supabase
        .from('presets')
        .select()
        .eq('user_id', user_id)
        .eq('sport_id', sport_id)

    if (data0[0])
        return data0[0];
    else
        return null;
}

async function updateClientPath(path) {
    const { data, error } = await supabase
        .from('clients')
        .update({
            model_start: path
        }) // Fields to update
        .eq('client_id', getUserId()) // Condition

    if (error) {
        //console.log(error)
    } else {
        cacheInvalidate("client:")
        window['toast']("Esse é o novo projeto padrão!", "info")
    }

}

async function editRegisteredName(model, thumbnailFile) {

    if (model.glb) {
        const { data: uploadData, error: uploadError } = await supabase.storage
            .from("3ds")
            .upload(model.path, model.glb, {
                upsert: true, // Prevent overwriting existing files
            });
    }

    if (model.svg) {

        var pathNew = model.path.replace(".glb", ".svg");

        const { data: uploadData2, error: uploadError2 } = await supabase.storage
            .from("3ds")
            .upload(pathNew, model.svg, {
                upsert: true, // Prevent overwriting existing files
            });
    }

    if (thumbnailFile) {
        const { data: uploadData3, error: uploadError3 } = await supabase.storage
            .from("3ds-thumbs")
            .upload(model.thumbnail, thumbnailFile, {
                upsert: true, // Prevent overwriting existing files
            });
    }

    const { data, error } = await supabase
        .from('3ds')
        .update({
            name: model.name
        }) // Fields to update
        .eq('id', model.id) // Condition
}

async function updateClientModelsSimulator(array) {

    const { data, error } = await supabase
        .from('clients')
        .update({
            simulator_models: JSON.stringify(array)
        }) // Fields to update
        .eq('client_id', getUserId()) // Condition

    if (error) {
    } else {
        cacheInvalidate("client:")
    }

}

//

async function registerNormal(file, fileThumb) {

    const path_id = getUserId() + "/" + uuidv4(); // Path in the bucket

    const { data: uploadData3, error: uploadError3 } = await supabase.storage
        .from("fabric")
        .upload(path_id, file, {
            upsert: false, // Prevent overwriting existing files
        });

    const { data: uploadData4, error: uploadError4 } = await supabase.storage
        .from("fabric_thumb")
        .upload(path_id, fileThumb, {
            upsert: false, // Prevent overwriting existing files
        });

    const { data, error } = await supabase
        .from('fabric')
        .insert([
            {
                user_id: getUserId(),
                path: path_id
            },
        ])
        .select();

    window['stateLoadinScreen2'](false);

    if (data) {
        return data[0];
    } else {
        //console.log(error)
    }
}

async function getNormals() {
    const uid = getUserId();
    if (!uid) return null;

    let { data: data0, error0 } = await supabase
        .from('fabric')
        .select()
        .eq('user_id', uid)

    if (data0)
        return data0;
    else
        return null;
}

// Busca tecidos customizados por IDs — sem depender de user_id.
// Usado no iframe para anon users que não têm localStorage.
export async function getFabricsByIds(ids) {
    if (!ids || ids.length === 0) return [];
    const { data, error } = await withTimeout(
        supabase
            .from('fabric')
            .select('*')
            .in('id', ids),
        10000,
        'getFabricsByIds'
    );
    if (error) {
        console.warn("[API] getFabricsByIds error:", error);
        return [];
    }
    return data || [];
}

async function deleteThing(id, path, table, bucket) {

    if (path) {
        const { data2, error2 } = await supabase
            .storage
            .from(bucket)
            .remove([path])
    }

    if (id) {
        const { error } = await supabase
            .from(table)
            .delete()
            .eq('id', id);
    }
}

async function defaltNormal(path) {
    const { data, error } = await supabase
        .from('presets')
        .update({
            fabric: path
        }) // Fields to update
        .eq('user_id', getUserId()) // Condition
}

//

export async function multipleSave(objects, thumb, name) {

    var back;

    if ($("#background-panel").css("background-image").includes("url")) {
        back = $("#background-panel").css("background-image");
    } else {
        back = $("#background-panel").css("background");
    }

    const { data, error } = await supabase
        .from("multiple")
        .insert({
            user_id: getUserId(),
            obj: JSON.stringify(objects),
            thumb: thumb,
            name: name,
            background: back,
            back_cover: $("#state-fundo").attr("data-state") == "checked"
        })
        .select()
        .single();

    if (error) {
        //console.error("Erro ao criar cena:", error);
        return null;
    }

    return data; // retorna a cena criada (id incluso)
}

export async function multipleGet() {
    const { data, error } = await supabase
        .from("multiple")
        .select("*")
        .eq("user_id", getUserId())

    if (error) {
        //console.error("Erro ao buscar cenas:", error);
        return [];
    }

    return data;
}

export async function multipleDelete(sceneId) {
    const { error } = await supabase
        .from("multiple")
        .delete()
        .eq("id", sceneId);

    if (error) {
        //console.error("Erro ao deletar cena:", error);
        return false;
    }

    return true;
}

//

function dataURLToBlob(dataURL) {
    const [header, base64] = dataURL.split(',');
    const mime = header.match(/:(.*?);/)[1];
    const binary = atob(base64);
    const len = binary.length;

    const buffer = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        buffer[i] = binary.charCodeAt(i);
    }

    return new Blob([buffer], { type: mime });
}


export async function uploadCategoryThumbnail(categoryId, dataUrl) {
    const blob = dataURLToBlob(dataUrl);
    const path = `category-thumbs/${categoryId}.png`;

    const { error } = await supabase.storage
        .from("images")
        .upload(path, blob, { upsert: true, contentType: "image/png" });

    if (error) {
        console.error("Erro ao enviar thumbnail da categoria:", error);
        return null;
    }

    return `https://nfghuenhuaecfyccyaib.supabase.co/storage/v1/object/public/images/${path}?${Date.now()}`;
}

export async function uploadLogoToSupabase(bucket, logo1, logo2) {

    var uploads;

    if (logo1.includes("https://") && logo2.includes("https://")) {
        return;
    } else if (logo1.includes("https://")) {

        const logo2Blob = dataURLToBlob(logo2);

        uploads = [
            {
                file: logo2Blob,
                path: `images/${getUserId()}/logo_2.png`
            }
        ];

    } else if (logo2.includes("https://")) {

        const logo1Blob = dataURLToBlob(logo1);

        uploads = [
            {
                file: logo1Blob,
                path: `images/${getUserId()}/logo_1.png`
            }
        ];

    } else {

        const logo1Blob = dataURLToBlob(logo1);
        const logo2Blob = dataURLToBlob(logo2);

        uploads = [
            {
                file: logo1Blob,
                path: `images/${getUserId()}/logo_1.png`
            },
            {
                file: logo2Blob,
                path: `images/${getUserId()}/logo_2.png`
            }
        ];
    }

    const results = await Promise.all(
        uploads.map(item =>
            supabase.storage
                .from(bucket)
                .upload(item.path, item.file, {
                    upsert: true,
                    contentType: item.file.type
                })
        )
    );

    const error = results.find(r => r.error);
    if (error) throw error.error;

}

export async function deleteLogoFromSupabase(bucket, logoNumber) {
    const userId = getUserId();

    if (!userId) {
        throw new Error("User ID não encontrado");
    }

    if (![1, 2].includes(logoNumber)) {
        throw new Error("logoNumber deve ser 1 ou 2");
    }

    const path = `images/${userId}/logo_${logoNumber}.png`;

    const { data, error } = await supabase.storage
        .from(bucket)
        .remove([path]);

    if (error) {
        throw error;
    }

    window['toast']("Logo deletada com sucesso!", "info")

    return data;
}

export async function supbaseManager(action, table, content, id) {

    if (action == "insert") {

        window['stateLoadinScreen2'](true);

        if (table == "iframe_options") {

            const { data, error } = await supabase
                .from(table)
                .select("id, project_id")
                .eq("project_id", content.project_id)

            if (data && data.length > 0) {
                const idd = data[0];

                const { data: updData, error: updError } = await supabase
                    .from(table)
                    .update({
                        options: content.options,
                    })
                    .eq("project_id", content.project_id)
                    .select();

                window['stateLoadinScreen2'](false);

                return idd;
            }
        }

        const { data, error } = await supabase
            .from(table)
            .insert(content)
            .select()
            .single();

        if (error) {
            //console.error("Erro ao criar cena:", error);
            return null;
        }

        window['stateLoadinScreen2'](false);

        cacheInvalidate(`mgr:${table}`)
        return data; // retorna a cena criada (id incluso)
    } else if (action == "get") {
        const cacheKey = `mgr:get:${table}:${id}`
        const cached = cacheGet(cacheKey, 30000)
        if (cached) return cached

        const _t = performance.now()
        try {
        const { data, error } = await withTimeout(
            supabase
                .from(table)
                .select("*")
                .eq("user_id", id),
            15000,
            `supbaseManager-get-${table}`
        )

        if (error) {
            //console.error("Erro ao buscar cenas:", error);
            return [];
        }

        if (data) cacheSet(cacheKey, data)
        return data;
        } catch (err) {
            console.warn(`[PERF-PROJECTS] supbaseManager get(${table}): ${err.message} (${(performance.now() - _t).toFixed(0)}ms)`)
            return [];
        }
    } else if (action == "all") {
        const cacheKey = `mgr:all:${table}`
        const cached = cacheGet(cacheKey, 30000)
        if (cached) { return cached }

        const _t = performance.now()
        try {
        const { data, error } = await withTimeout(
            supabase
                .from(table)
                .select("*"),
            15000,
            `supbaseManager-all-${table}`
        )

        if (error) {
            //console.error("Erro ao buscar cenas:", error);
            return [];
        }

        if (data) cacheSet(cacheKey, data)
        return data;
        } catch (err) {
            console.warn(`[PERF-PROJECTS] supbaseManager all(${table}): ${err.message} (${(performance.now() - _t).toFixed(0)}ms)`)
            return [];
        }
    } else if (action == "delete") {

        window['stateLoadinScreen2'](true);
        const { error } = await supabase
            .from(table)
            .delete()
            .eq("category_id", content);

        if (error) {
            //console.error("Erro ao deletar cena:", error);
            return false;
        }

        window['stateLoadinScreen2'](false);

        cacheInvalidate(`mgr:${table}`)
        return true;
    } else if (action == "update") {

        window['stateLoadinScreen2'](true);
        const { data, error } = await supabase
            .from(table)
            .update({
                json: content
            }) // Fields to update
            .eq('category_id', id) // Condition

        if (error) {
            //console.log(error)
        } else {
            cacheInvalidate(`mgr:${table}`)
            //console.log("sucesso")
        }

        window['stateLoadinScreen2'](false);
    } else if (action == "getByids") {
        if (!content || content.length === 0) return []
        const cacheKey = `byids:${table}:${content.sort().join(',')}`
        const cached = cacheGet(cacheKey, 30000)
        if (cached) { return cached }

        const _t = performance.now()
        try {
        const { data, error } = await withTimeout(
            supabase
                .from(table)
                .select("*")
                .in("id", content),
            15000,
            `supbaseManager-getByids-${table}`
        )

        if (error) {
            //console.error("Erro ao buscar cenas:", error);
            return [];
        }

        if (data) cacheSet(cacheKey, data)
        return data;
        } catch (err) {
            console.warn(`[PERF-PROJECTS] supbaseManager getByids(${table}): ${err.message} (${(performance.now() - _t).toFixed(0)}ms)`)
            return [];
        }
    }
}

export async function deletePreset(sport_id) {
    const { error } = await supabase
        .from("presets")
        .delete()
        .eq('user_id', getUserId())
        .eq('sport_id', sport_id)

    if (error) {
        //console.error("Erro ao deletar cena:", error);
        return false;
    }

    window['toast']("Predefinições Apagadas!", "info")

    return true;
}

// =========================================================
// BRIEFINGS — Vendedor cria, Designer executa
// =========================================================

// owner_id guarda o user_id literal de quem criou o briefing. Pra ver os
// briefings de toda a organização (mesmo "email" em clients), getBriefings()
// usa getOrgUserIds() e busca por todos os user_ids de uma vez — não precisa
// mais mapear todo mundo pra um único "dono" fixo.

// ── Criar briefing (a partir do 3-pontinhos da modelagem) ──────────────────
export async function createBriefing(payload) {
    window['stateLoadinScreen2'] && window['stateLoadinScreen2'](true);

    const { data, error } = await supabase
        .from('briefings')
        .insert([{
            owner_id: getUserId(),
            created_by: getUserId(),
            created_by_email: localStorage.getItem("user_email"),
            model_id: payload.model_id ? String(payload.model_id) : null,
            model_name: payload.model_name || null,
            model_thumb: payload.model_thumb || null,
            model_path: payload.model_path || null,
            client_name: payload.client_name || null,
            client_contact: payload.client_contact || null,
            vendedor_id: payload.vendedor_id || null,
            vendedor_name: payload.vendedor_name || null,
            designer_id: payload.designer_id || null,
            designer_name: payload.designer_name || null,
            title: payload.title,
            status: payload.status || 'pendente',
            priority: payload.priority || 'normal',
            deadline: payload.deadline || null,
            deadline_time: payload.deadline_time || null,
            duration: payload.duration || null,
            all_day: payload.all_day !== undefined ? payload.all_day : true,
            description: payload.description || null,
            collar: payload.collar || null,
            sleeve: payload.sleeve || null,
            sizes: payload.sizes || null,
            quantity: payload.quantity || null,
            fabric: payload.fabric || null,
            colors: payload.colors || [],
        }])
        .select()
        .single();

    window['stateLoadinScreen2'] && window['stateLoadinScreen2'](false);

    if (error) {
        console.error("Erro ao criar briefing:", error);
        window['toast'] && window['toast']("Erro ao criar briefing, tente novamente!", "info");
        return null;
    }

    if (payload.models?.length && data) {
        const modelRows = payload.models.map((m, i) => ({
            briefing_id: data.id,
            model_id: m.model_id || null,
            model_name: m.model_name || null,
            model_thumb: m.model_thumb || null,
            model_path: m.model_path || null,
            collar: m.collar || null,
            sleeve: m.sleeve || null,
            sizes: m.sizes || null,
            quantity: m.quantity || null,
            fabric: m.fabric || null,
            observation: m.observation || null,
            position: i,
        }));
        const { error: modelError } = await supabase.from('briefing_models').insert(modelRows);
        if (modelError) console.error("Erro ao criar modelos do briefing:", modelError);
    }

    window['toast'] && window['toast']("Briefing criado com sucesso!", "info");
    cacheInvalidate("briefings:")
    return data;
}

// ── Listar briefings da organização (com filtros opcionais) ────────────────
export async function getBriefings(filters = {}) {
    const myId = getUserId();
    const orgIds = await getOrgUserIds(myId);

    const filterKey = JSON.stringify({ orgIds: orgIds.sort(), ...filters })
    const cacheKey = `briefings:${filterKey}`
    const cached = cacheGet(cacheKey, 15000)
    if (cached) return cached

    const data = await dedupedQuery(cacheKey, async () => {
        let query = supabase
            .from('briefings')
            .select('id, owner_id, title, status, priority, model_name, model_path, model_thumb, model_id, client_name, client_contact, vendedor_id, vendedor_name, designer_id, designer_name, collar, sleeve, sizes, quantity, fabric, description, deadline, deadline_time, duration, all_day, designer_notes, designer_project_link, created_at, created_by')
            .in('owner_id', orgIds)
            .order('created_at', { ascending: false });

        if (filters.status) query = query.eq('status', filters.status);
        if (filters.designer_id) query = query.eq('designer_id', filters.designer_id);
        if (filters.vendedor_id) query = query.eq('vendedor_id', filters.vendedor_id);
        if (filters.from) query = query.gte('created_at', filters.from);
        if (filters.to) query = query.lte('created_at', filters.to);

        const { data: briefings, error } = await query;
        if (error || !briefings?.length) return briefings || [];

        const ids = briefings.map(b => b.id);
        const { data: models } = await supabase
            .from('briefing_models')
            .select('*')
            .in('briefing_id', ids)
            .order('position', { ascending: true });

        const modelsByBriefing = {};
        (models || []).forEach(m => {
            if (!modelsByBriefing[m.briefing_id]) modelsByBriefing[m.briefing_id] = [];
            modelsByBriefing[m.briefing_id].push(m);
        });

        return briefings.map(b => ({
            ...b,
            models: modelsByBriefing[b.id] || [],
        }));
    })

    cacheSet(cacheKey, data)
    return data;
}

export async function getBriefing(id) {
    const { data, error } = await supabase
        .from('briefings')
        .select('*')
        .eq('id', id)
        .single();

    if (error) {
        console.error("Erro ao buscar briefing:", error);
        return null;
    }

    return data;
}

// ── Editar briefing (usado tanto pelo vendedor quanto pelo designer) ───────
export async function updateBriefing(id, fields) {
    const clean = { ...fields }
    if (clean.deadline === "") clean.deadline = null
    if (clean.deadline_time === "") clean.deadline_time = null
    if (clean.vendedor_id === "") clean.vendedor_id = null
    if (clean.designer_id === "") clean.designer_id = null

    const { data, error } = await supabase
        .from('briefings')
        .update(clean)
        .eq('id', id)
        .select()
        .single();

    if (error) {
        console.error("Erro ao editar briefing:", error.message, error.details, error.hint);
        window['toast'] && window['toast']("Erro ao salvar alterações do briefing: " + (error.message || ""), "info");
        return null;
    }

    cacheInvalidate("briefings:")
    return data;
}

export async function deleteBriefing(id) {
    await supabase.from('briefing_models').delete().eq('briefing_id', id);

    const { error } = await supabase
        .from('briefings')
        .delete()
        .eq('id', id);

    if (error) {
        console.error("Erro ao deletar briefing:", error);
        return false;
    }

    cacheInvalidate("briefings:")
    window['toast'] && window['toast']("Briefing removido!", "info");
    return true;
}

// ── Briefing Models (múltiplos modelos por briefing) ────────────────────────
export async function getBriefingModels(briefingId) {
    const { data, error } = await supabase
        .from('briefing_models')
        .select('*')
        .eq('briefing_id', briefingId)
        .order('position', { ascending: true });

    if (error) {
        console.error("Erro ao buscar modelos do briefing:", error);
        return [];
    }
    return data || [];
}

export async function addBriefingModel(briefingId, modelData) {
    const { data, error } = await supabase
        .from('briefing_models')
        .insert([{
            briefing_id: briefingId,
            model_id: modelData.model_id || null,
            model_name: modelData.model_name || null,
            model_thumb: modelData.model_thumb || null,
            model_path: modelData.model_path || null,
            collar: modelData.collar || null,
            sleeve: modelData.sleeve || null,
            sizes: modelData.sizes || null,
            quantity: modelData.quantity || null,
            fabric: modelData.fabric || null,
            observation: modelData.observation || null,
            position: modelData.position || 0,
        }])
        .select()
        .single();

    if (error) {
        console.error("Erro ao adicionar modelo ao briefing:", error);
        return null;
    }
    return data;
}

export async function updateBriefingModel(modelId, fields) {
    const { data, error } = await supabase
        .from('briefing_models')
        .update(fields)
        .eq('id', modelId)
        .select()
        .single();

    if (error) {
        console.error("Erro ao atualizar modelo do briefing:", error);
        return null;
    }
    return data;
}

export async function removeBriefingModel(modelId) {
    const { error } = await supabase
        .from('briefing_models')
        .delete()
        .eq('id', modelId);

    if (error) {
        console.error("Erro ao remover modelo do briefing:", error);
        return false;
    }
    return true;
}

// ── Anexos (logos, patrocinadores, referências, arte final) ────────────────
export async function uploadBriefingAttachment(briefingId, file, kind = 'referencia') {
    const cleanName = file.name.replace(/[^a-zA-Z0-9._-]/g, "_");
    const path = `${briefingId}/${kind}/${uuidv4()}_${cleanName}`;

    const { error: uploadError } = await supabase.storage
        .from('briefing-attachments')
        .upload(path, file, { upsert: true, contentType: file.type });

    if (uploadError) {
        console.error("Erro ao subir anexo do briefing:", uploadError);
        window['toast'] && window['toast']("Erro ao enviar anexo!", "info");
        return null;
    }

    const publicUrlData = { publicUrl: cachedGetPublicUrl('briefing-attachments', path) };

    const { data, error } = await supabase
        .from('briefing_attachments')
        .insert([{
            briefing_id: briefingId,
            kind,
            file_url: publicUrlData.publicUrl,
            file_path: path,
            file_name: file.name,
            uploaded_by: getUserId(),
            uploaded_by_name: localStorage.getItem("user_email"),
        }])
        .select()
        .single();

    if (error) {
        console.error("Erro ao registrar anexo do briefing:", error);
        return null;
    }

    return data;
}

export async function getBriefingAttachments(briefingId) {
    const { data, error } = await supabase
        .from('briefing_attachments')
        .select('*')
        .eq('briefing_id', briefingId)
        .order('created_at', { ascending: true });

    if (error) {
        console.error("Erro ao buscar anexos do briefing:", error);
        return [];
    }

    return data;
}

export async function deleteBriefingAttachment(attachmentId, filePath) {
    if (filePath) {
        await supabase.storage.from('briefing-attachments').remove([filePath]);
    }

    const { error } = await supabase
        .from('briefing_attachments')
        .delete()
        .eq('id', attachmentId);

    if (error) {
        console.error("Erro ao remover anexo do briefing:", error);
        return false;
    }

    return true;
}

// ── Comentários (comunicação vendedor <-> designer) ─────────────────────────
export async function addBriefingComment(briefingId, message, authorRole = 'vendedor') {
    const { data, error } = await supabase
        .from('briefing_comments')
        .insert([{
            briefing_id: briefingId,
            author_id: getUserId(),
            author_name: localStorage.getItem("user_email"),
            author_role: authorRole,
            message,
        }])
        .select()
        .single();

    if (error) {
        console.error("Erro ao adicionar comentário:", error);
        return null;
    }

    return data;
}

export async function getBriefingComments(briefingId) {
    const { data, error } = await supabase
        .from('briefing_comments')
        .select('*')
        .eq('briefing_id', briefingId)
        .order('created_at', { ascending: true });

    if (error) {
        console.error("Erro ao buscar comentários:", error);
        return [];
    }

    return data;
}

// =========================================================
// ORGANIZAÇÃO — todos os acessos (user_ids) de uma mesma loja
// =========================================================
// A loja pode ter vários logins/acessos diferentes (user_id diferente para
// cada um). A única coisa em comum entre eles, na tabela "clients", é o
// "email" (o email principal da loja). Essa função devolve todos os
// user_ids (client_id) que compartilham esse mesmo email, incluindo o
// próprio clientId — usada pra agregar dados (como categorias) espalhados
// entre os vários acessos da mesma loja.
const _orgUserIdsCache = new Map()
export async function getOrgUserIds(clientId) {
    if (!clientId) return [];

    const cacheKey = `orguids:${clientId}`
    const cached = _orgUserIdsCache.get(cacheKey)
    if (cached && Date.now() - cached.ts < 300000) return cached.data

    const _t = performance.now()
    try {
    const { data: mine, error: mineError } = await withTimeout(
        supabase
            .from('clients')
            .select('email')
            .eq('client_id', clientId),
        10000,
        'getOrgUserIds-1'
    );

    if (mineError || !mine || !mine.length || !mine[0].email) {
        if (mineError) console.error("Erro ao buscar email da loja:", mineError);
        // Sem email pra cruzar, ao menos devolve o próprio id.
        return [clientId];
    }

    const mainEmail = mine[0].email;

    const { data, error } = await withTimeout(
        supabase
            .from('clients')
            .select('client_id')
            .eq('email', mainEmail),
        10000,
        'getOrgUserIds-2'
    );

    if (error || !data || !data.length) {
        if (error) console.error("Erro ao buscar acessos da loja:", error);
        return [clientId];
    }

    const ids = data.map((c) => c.client_id).filter(Boolean);

    // Garante que o próprio clientId está na lista, mesmo que por algum
    // motivo não tenha voltado na query acima.
    if (!ids.includes(clientId)) ids.push(clientId);

    const result = Array.from(new Set(ids));
    _orgUserIdsCache.set(cacheKey, { data: result, ts: Date.now() })
    return result;
    } catch (err) {
        console.warn(`[PERF-PROJECTS] getOrgUserIds: ${err.message} (${(performance.now() - _t).toFixed(0)}ms)`);
        return [clientId];
    }
}

// =========================================================
// EQUIPE — Designers e Vendedores
// =========================================================
// Não existe cadastro separado: cada usuário tem sua própria linha em
// "clients" (client_id = seu user_id) e só escolhe o próprio cargo
// ("role") em "Dados da Loja", salvo junto com o resto pelo registerClient.
// Pra montar a lista de designers/vendedores da organização, buscamos
// todas as linhas de "clients" que compartilham o mesmo "email principal"
// (o campo "email" da própria pessoa) e filtramos pelo cargo.

export async function getTeamMembers(role) {
    const myId = getUserId();

    const { data: mine, error: mineError } = await supabase
        .from('clients')
        .select('email')
        .eq('client_id', myId);

    if (mineError || !mine || !mine.length || !mine[0].email) {
        if (mineError) console.error("Erro ao buscar loja do usuário atual:", mineError);
        return [];
    }

    const mainEmail = mine[0].email;

    let query = supabase
        .from('clients')
        .select('client_id, user_name, email, role')
        .eq('email', mainEmail)
        .not('role', 'is', null);

    if (role) query = query.eq('role', role);

    const { data, error } = await query;

    if (error) {
        console.error("Erro ao buscar equipe:", error);
        if (String(error.message || "").toLowerCase().includes("column") && String(error.message || "").toLowerCase().includes("role")) {
            console.warn('[Equipe] A coluna "role" não existe na tabela "clients" ainda. Rode o SQL supabase_clients_role_column.sql.');
        }
        return [];
    }

    return (data || []).map((c) => ({ id: c.client_id, name: c.user_name || c.email, email: c.email, role: c.role }));
}

export default Auth;

export async function saveFolder(name, parentId) {

    const payload = {
        user_id: getUserId(),
        name: name,
    };

    // 👇 só adiciona se existir
    if (parentId !== null && parentId !== undefined) {
        payload.parentId = parentId;
    }

    const { data, error } = await supabase
        .from("folders")
        .insert(payload)
        .select()
        .single();

    if (error) {
        console.error(error);
        return false;
    }

    window['toast']("Pasta Salva!", "info")

    return data;
}

export async function deleteFolder(id) {

    const { error } = await supabase
        .from("folders")
        .delete()
        .eq('id', id)

    if (error) { return false }

    window['toast']("Pasta Apagada!", "info")

    return true
}

export async function updateFolderName(id, name) {

    const { error } = await supabase
        .from("folders")
        .update({
            name: name
        }) // Fields to update
        .eq('id', id) // Condition

    if (error) { return false }

    window['toast']("Pasta Renomeada!", "info")

    return true
}

export async function updateFolderProjects(id, content) {

    const { error } = await supabase
        .from("folders")
        .update({
            projectIds: content
        }) // Fields to update
        .eq('id', id) // Condition

    if (error) { return false }

    window['toast']("Pasta Atualizada!", "info")

    return true
}

export async function editRegisteredNameSimulator(id_sport, name) {

    const user_id = getUserId();

    await supabase
        .from('names')
        .delete()
        .eq('user_id', user_id)
        .eq('id_sport', id_sport);

    const { data, error } = await supabase
        .from('names')
        .insert({
            name: name,
            user_id: user_id,
            id_sport: id_sport
        });

    if (error) console.error(error);
}

export async function getRegisteredNameSimulator() {
    const myId = getUserId();
    const orgIds = await getOrgUserIds(myId);
    const { data, error } = await supabase
        .from("names")
        .select("*")
        .in("user_id", orgIds)

    return data
}

export async function saveLightParams(params) {

    const user_id = getUserId()

    const { data, error } = await supabase
        .from("light")
        .upsert(
            {
                user_id: user_id,
                params: params
            },
            {
                onConflict: "user_id"
            }
        );

    if (error) {
        alert("erro ao salvar");
        console.error(error);
    } else {
        window["toast"]("Parâmetros salvos com sucesso!", "info");
    }
}

//

export async function getSharedData(id) {
    const cacheKey = `iframe_options:${id}`
    const cached = cacheGet(cacheKey, 60000)
    if (cached) return cached

    const data = await dedupedQuery(cacheKey, async () => {
        const { data, error } = await supabase
            .from("iframe_options")
            .select()
            .eq("id", id)
        return data
    })

    if (data) cacheSet(cacheKey, data)
    return data
}

export async function deleteColorTable(id) {

    const { error } = await supabase
        .from("color-tables")
        .delete()
        .eq('id', id)

    if (error) { return false }

    window['toast']("Tabela Apagada!", "info")

    return true
}

export async function saveForm(file) {

    const userId = getUserId();

    const { data: uploadData5, error: uploadError5 } = await supabase.storage
        .from("forms")
        .upload(userId, file, {
            upsert: true, // não sobrescreve no storage
        });

    if (uploadError5) {
        console.error(uploadError5);
        return;
    }

    const { data, error } = await supabase
        .from('forms')
        .upsert({
            client_id: userId,
            json: userId
        }, {
            onConflict: 'client_id',
            ignoreDuplicates: true // 👈 ESSA LINHA resolve seu problema
        });

    if (error) {
        console.error(error);
        return;
    }

    //window['toast']("Formulário Salvo!", "info");
    window.alert("Formulário Salvo! Ele será carregado automaticamente na próxima vez que você acessar o simulador. Você também pode exportar esse formulário para usá-lo em outros lugares, como no kit de vendas ou em outro projeto.");
}

export async function getFormByClientId(id) {
    const userId = id;

    const { data, error } = await supabase.storage
        .from('forms')
        .download(userId);

    if (error) {
        console.error(error);
        return null;
    }

    // data é um Blob → precisa converter pra texto
    const text = await data.text();

    return JSON.parse(text);
}

export async function edit3D(id, data, thumb) {

    window['stateLoadinScreen2'](true);

    try {

        const getExtension = file => file.name.split('.').pop().toLowerCase();

        // Busca dados atuais
        const { data: current3D, error: fetchError } = await supabase
            .from("3ds")
            .select("*")
            .eq("id", id)
            .single();

        if (fetchError) throw fetchError;

        let currentPath = current3D.path;
        let thumbName = current3D.thumb2;

        // =========================================
        // ATUALIZA OBJ / SVG
        // =========================================
        if (data.obj || data.svg) {

            const basePath = currentPath;

            const files = [];

            if (data.obj) files.push(data.obj);
            if (data.svg) files.push(data.svg);

            await Promise.all(
                files.map(file => {
                    const extension = getExtension(file);

                    return supabase.storage
                        .from("3ds")
                        .upload(
                            `${basePath}.${extension}`,
                            file,
                            { upsert: true }
                        );
                })
            );
        }

        // =========================================
        // ATUALIZA THUMB
        // =========================================
        if (thumb) {

            await supabase.storage
                .from("images")
                .upload(
                    thumbName,
                    thumb,
                    { upsert: true }
                );
        }

        // Thumbnail secundária
        if (data.thumbnail) {

            await supabase.storage
                .from("images")
                .upload(
                    thumbName + "-2",
                    data.thumbnail,
                    { upsert: true }
                );
        }

        // =========================================
        // TECIDOS
        // =========================================
        let arrayTecidosPaths = [];

        if (data.tecidos && data.tecidos.length > 0) {
            await Promise.all(
                data.tecidos.map(async (item, index) => {
                    const key = `tecido${index + 1}`

                    // Item existente — mantém a URL do banco
                    if (!item.file && item.existingUrl) {
                        // extrai só o path relativo (remove a base URL)
                        const path = item.existingUrl.replace(
                            "https://nfghuenhuaecfyccyaib.supabase.co/storage/v1/object/public/tecidos/",
                            ""
                        )
                        arrayTecidosPaths.push({ [key]: path })
                        return
                    }

                    // Item novo — faz upload
                    if (item.file) {
                        const extension = getExtension(item.file)
                        const path = `${thumbName}/${key}${Math.random()}.${extension}`
                        arrayTecidosPaths.push({ [key]: path })
                        return supabase.storage
                            .from("tecidos")
                            .upload(path, item.file, { upsert: true })
                    }
                })
            )
        } else {
            arrayTecidosPaths = JSON.parse(current3D.tecidos || "[]")
        }

        // =========================================
        // ESCUDOS
        // =========================================
        let arrayEscudosPaths = [];

        if (data.escudos && data.escudos.length > 0) {
            await Promise.all(
                data.escudos.map(async (item, index) => {
                    const key = `escudo${index + 1}`

                    // Item existente — mantém a URL do banco
                    if (!item.file && item.existingUrl) {
                        const path = item.existingUrl.replace(
                            "https://nfghuenhuaecfyccyaib.supabase.co/storage/v1/object/public/escudos/",
                            ""
                        )
                        arrayEscudosPaths.push({ [key]: path })
                        return
                    }

                    // Item novo — faz upload
                    if (item.file) {
                        const extension = getExtension(item.file)
                        const path = `${thumbName}/${key}${Math.random()}.${extension}`
                        arrayEscudosPaths.push({ [key]: path })
                        return supabase.storage
                            .from("escudos")
                            .upload(path, item.file, { upsert: true })
                    }
                })
            )
        } else {
            arrayEscudosPaths = JSON.parse(current3D.escudos || "[]")
        }

        // =========================================
        // UPDATE NO BANCO
        // =========================================
        const { data: updatedData, error: updateError } = await supabase
            .from("3ds")
            .update({
                name: data.name,
                category: data.category,
                collar: data.collar,
                desc: data.desc,
                discount: data.discount,
                price: data.price,
                sizes: data.sizes,
                sleeve: data.sleeve,
                tecidos: JSON.stringify(arrayTecidosPaths),
                escudos: JSON.stringify(arrayEscudosPaths),
                form: data.form
            })
            .eq("id", id)
            .select()
            .single();

        if (updateError) throw updateError;

        window['toast']("3D atualizado com sucesso!", "info");

        // recarrega lista
        //window["populateObjs"](updatedData);

    } catch (err) {

        console.error(err);

        window['toast']("Erro ao atualizar 3D!", "error");
    }

    window['stateLoadinScreen2'](false);
}

export async function saveBaseModel(path) {
    window['stateLoadinScreen2'](true);

    try {
        // data.basePath = caminho já existente no storage (ex: "models/camisa-polo")
        // data.baseThumb = nome/path da thumb já existente (ex: "camisa-polo-thumb.webp")

        const { data: inserted, error } = await supabase
            .from("3ds")
            .insert({
                name: "modelagem",
                path: path + "glb",       // reutiliza o path já existente
                thumb2: path + "webp",    // reutiliza a thumb já existente
                user_id: getUserId(),
            })
            .select()
            .single();

        if (error) throw error;

        window['toast']("Modelo salvo com sucesso!", "info");
        return inserted;

    } catch (err) {
        console.error(err);
        window['toast']("Erro ao salvar modelo base!", "error");
        return null;
    } finally {
        window['stateLoadinScreen2'](false);
    }
}

export async function getAllWithEmail(email) {
    const cacheKey = `simulator:email:${email}`
    const cached = cacheGet(cacheKey, 30000)
    if (cached) { return cached }

    const _t = performance.now()
    // pega todos os clientes com o mesmo email
    const { data: clients, error: clientsError } = await supabase
        .from('clients')
        .select('client_id')
        .eq('email', email)

    if (clientsError) {
        console.error(clientsError)
        return []
    }

    // pega todos os client_id
    const clientIds = clients.map(client => client.client_id)

    if (clientIds.length === 0) return []

    const _t2 = performance.now()
    // busca todos os projetos da tabela simulator
    // onde user_id está dentro dos clientIds
    const { data: projects, error: projectsError } = await supabase
        .from('simulator')
        .select('id, user_id, name, svg_path, svg_thumb_path, created_at, sport_id, body_state, socks_state, up_state, down_state, clone_state, images, inside_color, up_state2, collar, designer, productionOrder, file_path')
        .in('user_id', clientIds)

    if (projectsError) {
        console.error(projectsError)
        return []
    }

    if (projects) cacheSet(cacheKey, projects)
    return projects
}

// =============================================
// SETUP MODULAR — Salvar / Atualizar / Carregar
// =============================================

export async function saveModularSetup(name, parts, thumbBlob) {
    const userId = getUserId();
    const path_id = userId + "/" + uuidv4();

    // Upload da thumbnail
    let thumbUrl = null;
    if (thumbBlob) {
        const { error: thumbErr } = await supabase.storage
            .from("images")
            .upload(path_id + "_thumb", thumbBlob, { upsert: true, contentType: "image/webp" });
        if (!thumbErr) {
            thumbUrl = "https://nfghuenhuaecfyccyaib.supabase.co/storage/v1/object/public/images/" + path_id + "_thumb";
        }
    }

    const { data, error } = await supabase
        .from("3ds")
        .insert({
            name: name,
            user_id: userId,
            setup_data: JSON.stringify(parts),
            thumb2: thumbUrl || "",
            path: "",
        })
        .select()
        .single();

    if (error) {
        console.error("[saveModularSetup] erro:", error);
        window['toast']("Erro ao salvar setup modular!", "error");
        return null;
    }

    window['toast']("Setup modular salvo com sucesso!", "info");
    return data;
}

export async function updateModularSetup(id, parts, thumbBlob) {
    const userId = getUserId();
    const path_id = userId + "/" + uuidv4();

    let thumbUrl = null;
    if (thumbBlob) {
        const { error: thumbErr } = await supabase.storage
            .from("images")
            .upload(path_id + "_thumb", thumbBlob, { upsert: true, contentType: "image/webp" });
        if (!thumbErr) {
            thumbUrl = "https://nfghuenhuaecfyccyaib.supabase.co/storage/v1/object/public/images/" + path_id + "_thumb";
        }
    }

    const updatePayload = {
        setup_data: JSON.stringify(parts),
    };

    if (thumbUrl) {
        updatePayload.thumb2 = thumbUrl;
    }

    const { data, error } = await supabase
        .from("3ds")
        .update(updatePayload)
        .eq("id", id)
        .select()
        .single();

    if (error) {
        console.error("[updateModularSetup] erro:", error);
        window['toast']("Erro ao atualizar setup modular!", "error");
        return null;
    }

    window['toast']("Setup modular atualizado!", "info");
    return data;
}

export async function loadModularSetup(id) {
    const { data, error } = await supabase
        .from("3ds")
        .select("*")
        .eq("id", id)
        .single();

    if (error) {
        console.error("[loadModularSetup] erro:", error);
        return null;
    }

    if (data && data.setup_data) {
        data.setup_data = typeof data.setup_data === "string"
            ? JSON.parse(data.setup_data)
            : data.setup_data;
    }

    return data;
}

export async function getMySaved3dsModular() {
    const userId = getUserId();
    const orgIds = await getOrgUserIds(userId);

    const { data, error } = await supabase
        .from("3ds")
        .select("*")
        .in("user_id", orgIds)
        .not("setup_data", "is", null);

    if (error) {
        console.error("[getMySaved3dsModular] erro:", error);
        return [];
    }

    return data || [];
}

export async function deleteModularSetup(id) {
    const { error } = await supabase
        .from("3ds")
        .delete()
        .eq("id", id);

    if (error) {
        console.error("[deleteModularSetup] erro:", error);
        return false;
    }
    return true;
}

// ── Rastreamento de acessos ao iframe ──────────────────────────────────────────
export async function trackIframeAccess(ownerId, projectId) {
    try {
        let location = null
        try {
            const res = await fetch("https://ipapi.co/json/", {
                signal: AbortSignal.timeout(3000),
            })
            const data = await res.json()
            if (!data.error) {
                location = {
                    country: data.country_name || null,
                    region: data.region || null,
                    city: data.city || null,
                    lat: data.latitude || null,
                    lon: data.longitude || null,
                }
            }
        } catch (_) { /* falha silenciosa */ }

        const { error } = await supabase.from("iframe_accesses").insert({
            owner_id: ownerId,
            project_id: projectId || null,
            accessed_at: new Date().toISOString(),
            user_agent: navigator.userAgent || null,
            country: location?.country || null,
            region: location?.region || null,
            city: location?.city || null,
            lat: location?.lat || null,
            lon: location?.lon || null,
        })
        if (error) console.error("[trackIframeAccess] erro:", error.message)
    } catch (e) {
        console.error("[trackIframeAccess] excecao:", e)
    }
}

export async function getIframeAccessDetails(ownerId) {
    try {
        const { data, error } = await supabase
            .from("iframe_accesses")
            .select("accessed_at, country, region, city, lat, lon")
            .eq("owner_id", ownerId)
            .order("accessed_at", { ascending: false })
            .limit(500)
        if (error || !data) return []
        return data
    } catch (e) {
        return []
    }
}

export async function getIframeAccessCounts() {
    try {
        const { data, error } = await supabase
            .from("iframe_accesses")
            .select("owner_id")
        if (error || !data) return {}
        const counts = {}
        data.forEach((row) => {
            counts[row.owner_id] = (counts[row.owner_id] || 0) + 1
        })
        return counts
    } catch (e) {
        return {}
    }
}

export {
    getAllData, saveProject, editProject, deleteProjectAPI, getMySaved3ds, saveMy3d, deleteModel, registerAPI, getRegisteredAPI,
    deleteRegisteredAPI, registerClient, getClient, registerCatalog, getCatalogs, getCatalog, deleteCatalog, editCatalog,
    registerImages, getImages, deleteImage, getRegisteredObjs, saveRegisteredObjThumb, deleteRegisteredObj, editRegisteredObj,
    getProject, registerSeller, getSellers, deleteSeller, registerCategory, getCategories, editCategory, deleteCategory,
    registerKit, getKits, deleteKit, editKit, registerProjectIframe, getProjectsIframe, deleteProjectIframe, updateClientBackground,
    registerPresets, saveFabricPreset, saveAnnotationPreset, getPresets, updateClientPath, editRegisteredName, updateClientModelsSimulator, registerNormal, getNormals,
    deleteThing, defaltNormal
}